import { Component, OnInit, Input } from '@angular/core';

import { MenuService, SubMenuItem, MenuItem } from '../services/menu.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'fw-submenu',
    template: require('./submenu.component.html'),
    styles: [require('./submenu.component.css')]
})
export class SubmenuComponent implements OnInit {
    private activeMenuItemSubscription: Subscription;
    private subitems: Array<SubMenuItem>;

    constructor(private menuService: MenuService) { }

    ngOnInit(): void {
        if (this.menuService.activeMenuItem != null && this.menuService.activeMenuItem.submenu != null) {
            this.subitems = this.menuService.activeMenuItem.submenu;
        }

        this.activeMenuItemSubscription = this.menuService.activeMenuItemChanged
            .subscribe((event) => {
                if (this.menuService.activeMenuItem != null && this.menuService.activeMenuItem.submenu != null) {
                    this.subitems = this.menuService.activeMenuItem.submenu;
                } else {
                    this.subitems = null;
                }
            });
    }

    ngOnDestroy(): void {
        this.activeMenuItemSubscription.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/menu/submenu.component.ts